import {gql} from '@apollo/client'

export const EXTEND_CHILDCARE_REQUEST = gql`
  query extendChildcareRequest($employeeId: ID!) {
    client {
      employee(employeeId: $employeeId) {
        id
        staffCode
        displayFullName
        user {
          id
          email
        }
      }
    }
  }
`

export interface ExtendChildcareRequestQueryVariables {
  employeeId: string
}

export interface ExtendChildcareRequestQueryResult {
  client: {
    employee: Employee
  }
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
  user?: {
    id: string
    email: string
  }
}
